import { render, staticRenderFns } from "./SelectedDepartmentDetail.vue?vue&type=template&id=9110d9ea&"
import script from "./SelectedDepartmentDetail.vue?vue&type=script&lang=js&"
export * from "./SelectedDepartmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports